/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Intro_BodyInputs */

const en_about_intro_body = /** @type {(inputs: About_Intro_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lindevo builds AI systems around these everyday realities. We bring software engineering and process design together, so useful technology can become a working part of your business.`)
};

const lv_about_intro_body = /** @type {(inputs: About_Intro_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lindevo veido AI sistēmas šiem ikdienas uzdevumiem. Apvienojam programmatūras izstrādi un procesu veidošanu, lai tehnoloģija kļūtu par noderīgu daļu no Jūsu uzņēmuma darba.`)
};

/**
* | output |
* | --- |
* | "Lindevo builds AI systems around these everyday realities. We bring software engineering and process design together, so useful technology can become a worki..." |
*
* @param {About_Intro_BodyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const about_intro_body = /** @type {((inputs?: About_Intro_BodyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Intro_BodyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_about_intro_body(inputs)
	return en_about_intro_body(inputs)
});